export default __webpack_public_path__ + "static/media/lubaantun2.cecf526d.webp";